<template lang="pug">
    v-card.px-5(height="100%")
        v-card-title.justify-center.main-title-primary.my-2 Administra
        v-row(style="height:80%")
            v-col.circular-center-column.pa-0(cols="6" v-for="card in categories")
                v-card.circular-card.d-flex.align-center.justify-center.my-4(@click="goTo(card.link)")
                    v-img(:src="card.icon" contain height="50")
                p(style="font-size: 12px") {{card.name}}
</template>

<script>
  export default {
    props: {
      changeTab: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      categories () {
        return [
          {
            name: 'Productos',
            icon: require('@/assets/icons/home/productos.png'),
            link: 'inventory',
          },
          {
            name: 'Métricas',
            icon: require('@/assets/icons/notifications/withdraw.png'),
            link: 'metrics',
          },
          {
            name: 'Ventas',
            icon: require('@/assets/icons/home/ordenes.png'),
            link: 'transactions/sales',
          },
          {
            name: 'Compras',
            icon: require('@/assets/icons/home/cargarinventario.png'),
            link: 'transactions/purchases',
          },
        ]
      },
    },
    methods: {
      goTo (link) {
        const vm = this
        if (vm.changeTab) {
          if (link !== 'inventory' && link !== 'metrics') vm.$router.push(`/dashboard/${link}`)
          else vm.$emit('changeTab', link)
        }
      },
    },
  }
</script>
